import { FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { StyledTextField } from "../../TextField/TextField";

export default function TaleoAPISection(props) {
  const useStyles = makeStyles((theme) => ({
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
  }));

  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Service Version"
          value={props.serviceVersion}
          error={props.showInputError && props.serviceVersion === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setServiceVersion(e.target.value)}
        />
        {props.showInputError && props.serviceVersion === "" && (
          <FormHelperText className={classes.error}>Service Version Required</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Username"
          value={props.username}
          error={props.showInputError && props.username === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setUsername(e.target.value)}
        />
        {props.showInputError && props.username === "" && (
          <FormHelperText className={classes.error}>Username Required</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Password"
          value={props.password}
          error={props.showInputError && props.password === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setPassword(e.target.value)}
        />
        {props.showInputError && props.password === "" && (
          <FormHelperText className={classes.error}>Password Required</FormHelperText>
        )}
      </Grid>
    </>
  );
}
